import { lazy, Suspense, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import {
  LoaderContainer,
  LoadingScreen,
  LoadingScreen2,
} from "./components/Loaders";

// CSS
import "./css/dependencies-resets/ReactDatePicker.css";
import "./css/dependencies-resets/ReactToastify.css";

// import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
// ASSETS
import { ReactComponent as PageNotFoundSvg } from "./assets/page_not_found.svg";

// HOOKS
import useDarkMode from "./hooks/useDarkMode";

// COMPONENTS
import LandingPage from "./pages/LandingPage";
import CheckAuth from "./components/Auth/CheckAuth";
import { ResetPassword } from "./features/Authentication";
import { useSelector } from "react-redux";

// LAZY COMPONENTS
const AuthPage = lazy(() => import("./pages/AuthPage"));
const MainPage = lazy(() => import("./pages/MainPage"));

function App() {
  // SETTING INITIAL THEME
  useDarkMode();
  const { darkTheme } = useSelector((state) => state.uiState);

  return (
    <Suspense fallback={<LoadingScreen2 />}>
      <Routes>
        <Route path="/">
          <Route path="/" element={<CheckAuth path={"/"} />} />
          <Route path="*" element={<LandingPage />} />
          <Route path="sign-up" element={<AuthPage signUp />} />
          <Route
            path="login"
            element={
              <CheckAuth path="login">
                <AuthPage login />
              </CheckAuth>
            }
          />
          <Route path="forgot-pw" element={<AuthPage forgot />} />
          <Route path="reset-pw" element={<ResetPassword />} />
          <Route path="verify-email/*" element={<h1>Email verified</h1>} />
          <Route
            path="app/*"
            element={
              <CheckAuth path="app">
                <MainPage />
              </CheckAuth>
            }
          />

          <Route
            path="not-found"
            element={
              <LoaderContainer fullscreen>
                <PageNotFoundSvg />
              </LoaderContainer>
            }
          />
        </Route>
        {/* <Route path="*" element={<Navigate to="not-found" />} /> */}
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme={darkTheme ? "dark" : "light"}
      />
    </Suspense>
  );
}

export default App;

// return (
//   <Suspense fallback={<LoadingScreen />}>
//     <Routes>
//       <Route path="/" element={<Navigate to="/home" replace />} />
//       <Route path="/welcome" element={<LandingPage />} />
//       <Route path="/*" element={<CheckAuth loading={loading} />} />
//       <Route path="/not-found" element={<ErrorMessage />} />
//     </Routes>
//   </Suspense>
// );
